/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `owner` - Owner
 * * `admin` - Admin
 * * `employee` - Employee
 */
export enum OrganizationRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  EMPLOYEE = 'employee',
}
